import React, {FC} from "react"
import {Body, H2} from "@irati/ui/src/Typography"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {MaterialSymbol} from "react-material-symbols"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {ButtonRouterLink} from "@irati/ui/src/Link"

import {
  BenefitIconContainer,
  BenefitInfoContentCard,
  BenefitTilesCard,
  BenefitTilesContainer,
  BenefitInfoLogo,
  BenefitMarkdown
} from "../../styled"

type MaterialSymbolName = Parameters<typeof MaterialSymbol>[0]["icon"]

interface Props {
  title?: string
  body?: string
  ctaText?: string
  secondCtaText?: string
  ctaUrl?: string
  secondCtaUrl?: string
  logoSrc?: string
  tilesData?: Array<{
    description: string
    iconBgColor: string
    icon?: string
    iconName: MaterialSymbolName
    iconColor: string
  }>
}

export const BenefitTextContent: FC<Props> = ({title, body, ctaText, tilesData, logoSrc, ctaUrl, secondCtaText, secondCtaUrl}) => {
  const {formatMessage} = useIntl()
  const theme = useTheme()
  const paragraphs = body?.split("\n\n")

  return (
    <BenefitInfoContentCard>
      {title && (
        <H2 color={theme.colors.primary2}>
          <FormattedMessage id={title} />
        </H2>
      )}
      {paragraphs && <BenefitMarkdown source={paragraphs?.join("\n\n")} />}
      {tilesData && (
        <BenefitTilesContainer>
          {tilesData.map((tile, index) => (
            <BenefitTilesCard key={index}>
              <BenefitIconContainer bgColor={tile.iconBgColor}>
                {tile?.icon && <img src={tile?.icon} alt={"icons"} />}
                {tile.iconName && <MaterialSymbol icon={tile.iconName} color={tile.iconColor} size={24} />}
              </BenefitIconContainer>
              <Body>{formatMessage({id: tile?.description})}</Body>
            </BenefitTilesCard>
          ))}
        </BenefitTilesContainer>
      )}
      {logoSrc && (
        <Flex justifyContent="center">
          <BenefitInfoLogo src={logoSrc} alt={"alt"} />
        </Flex>
      )}
      <Flex justifyContent="space-between" direction="row" marginTop={2} gap={1}>
        {ctaText && ctaUrl && (
          <ButtonRouterLink to={formatMessage({id: ctaUrl})} primary mobileFull onClick={() => {}}>
            <Body weight={"bold"} color={theme.colors.greys.white}>
              <FormattedMessage id={ctaText} />
            </Body>
          </ButtonRouterLink>
        )}
        {secondCtaText && secondCtaUrl && (
          <ButtonRouterLink to={formatMessage({id: secondCtaUrl})} mobileFull onClick={() => {}}>
            <Body weight={"bold"} color={theme.colors.primary2}>
              <FormattedMessage id={secondCtaText} />
            </Body>
          </ButtonRouterLink>
        )}
      </Flex>
    </BenefitInfoContentCard>
  )
}
